const preprod = require('./preprod');
const production = require('./production');
const staging = require('./staging');
const utils = require('../src/utils/utils');
const ENV = utils.isBrowser() && window.chartsEnvironment ? window.chartsEnvironment : 'staging';

function getConfig() {
  switch (ENV) {
    case 'staging':
      return staging;
    case 'production':
      return production;
    case 'preprod':
      return preprod;
    default:
      return staging;
  }
}

module.exports = {
  ENV,
  PORT: 8080,
  getConfig
};